export default __webpack_public_path__ + "static/media/Notice of Annual Shareholder's Meeting 2021.dc9654d6.pdf";